import { render, staticRenderFns } from "./Nuova.vue?vue&type=template&id=437be9f4"
import script from "./Nuova.vue?vue&type=script&lang=js"
export * from "./Nuova.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports